var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaper02Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1469_6950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.625 68.75C248.61 68.75 264 53.3598 264 34.375C264 15.3902 248.61 0 229.625 0C210.64 0 195.25 15.3902 195.25 34.375C195.25 53.3598 210.64 68.75 229.625 68.75Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 264C44.0442 264 79.75 228.294 79.75 184.25H0V264Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8691 138.259V34.8684C23.8691 29.673 28.0792 25.4629 33.2746 25.4629H230.73C235.925 25.4629 240.135 29.673 240.135 34.8684V48.537",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.34 113.03H172.576V49.5H49.5027V145.509C49.5027 148.155 51.6555 150.305 54.2994 150.305H91.0487V150.119L91.066 150.112V213.835H214.136V117.827C214.136 115.181 211.984 113.03 209.34 113.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.247 113.312V98.6558M90.9063 150.121H54.1595C51.6123 150.121 49.5488 148.058 49.5488 145.51V49.6855H172.247V65.9144C172.247 70.3332 175.83 73.9152 180.249 73.9144L230.722 73.9058C236 73.9058 240.28 78.1856 240.28 83.4639V232.395C240.28 237.591 236.07 241.801 230.875 241.801H33.4196C28.2242 241.801 24.0142 237.591 24.0142 232.395V173.186L24.0175 173.189C24.0175 167.911 28.2972 163.631 33.5756 163.631H83.1111C87.5294 163.631 91.1111 160.049 91.1111 155.631V119.61C91.1111 117.348 89.6478 115.346 87.4925 114.657L84.5732 113.724M55.043 150.121L82.9776 115.019C83.8828 113.88 85.2594 113.216 86.7152 113.216H209.195C211.743 113.216 213.806 115.279 213.806 117.826L213.812 213.651H91.1111V188.638",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1433 62.8809H82.9562",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.323 62.8809H158.497",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.186 72.5537H158.498",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8154 136.602H97.016",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.748 136.602H203.971",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.833 136.602H214.034",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.868 172.698V202.696",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.049 172.698V202.696",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.964 172.698V196.704",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.064 172.698V196.704",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.159 172.698V196.704",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.26 172.698V196.704",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.361 172.698V196.704",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.456 172.698V196.704",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.556 172.698V196.704",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.652 172.698V196.704",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.752 172.698V196.704",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.847 172.698V196.704",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.948 172.698V196.704",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1469_6950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 264,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper02Icon);
export default __webpack_public_path__ + "static/media/paper02-icon.e1686131.svg";
export { ForwardRef as ReactComponent };